import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20flowing%20waves%20with%20coral%20and%20cream%20tones%2C%20soft%20overlapping%20geometric%20shapes%2C%20minimalist%20modern%20design%2C%20gentle%20light%20rays%2C%20elegant%20sophisticated%20technology%20backdrop%2C%20clean%20professional%20aesthetic&width=1800&height=600&seq=cta-bg-17c&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-900/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开始使用 17c.cc 了吗？
        </h2>
        <p className="text-background-200/90 text-base mb-10 max-w-xl mx-auto leading-relaxed">
          立即访问 17c.cc 官方入口，开启您的流畅体验之旅。我们为您准备了详尽的使用指南和贴心的客户服务。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/guide"
            className="px-8 py-3.5 bg-background-50 text-primary-700 font-semibold rounded-lg hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>
            开始阅读指南
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-transparent text-background-50 font-semibold rounded-lg border border-background-50/40 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-contacts-line mr-2"></i>
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}